module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-1p-5650ca4d9227ecdbaa4c26c34b07a576.svg";